module.exports = __webpack_public_path__ + "img/player-back-icon.0f218831.svg";